import { RiskPicker } from 'application/Shared/Components/Pickers/Risk';
import { RISKS } from 'application/Shared/Constants';
import React from 'react';

const filterableOptions = [];
RISKS.forEach((risk) => {
    filterableOptions.push({
        name: risk,
        parameter: 'riskFilter',
        render: <RiskPicker visualOnly value={risk} />,
        value: risk
    });
});

const header = {
    filterable: true,
    filterableOptions,
    key: 'application.risk',
    name: 'Common.risk',
    sortable: true,
    sortableFieldType: 'risk',
    sortablekey: 'application.risk',
    squish: true,
    tooltip: 'risk',
    width: '10%'
};

export default header;
